import Swiper from 'swiper/swiper-bundle';

export default class SwiperInit {
  constructor (options) {
    // Header
    this.selector = options.selector || '',
    this.autoplay = options.autoplay || false,
    this.effect = options.effect || '',
    this.fadeEffect = options.fadeEffect || '',
    this.disableOnInteraction = options.disableOnInteraction || false,
    this.manualLoop = options.manualLoop || false,
    this.speed = options.speed || 400,
    this.spaceBetween = options.spaceBetween || 100,
    this.slidesOffsetBefore = options.slidesOffsetBefore || 0,
    this.slidesOffsetAfter = options.slidesOffsetAfter || 0,
    this.autoHeight = options.autoHeight || false,
    this.slidesPerView = options.slidesPerView || 1,
    this.breakPoints = options.breakPoints || '',
    this.navigation = options.navigation || '',
    this.pagination = options.pagination || '',
    this.run()
  }
  run() {
    if (this.selector) {
      if (this.manualLoop) {
        let navNext, navPrev, pagin
        if (this.navigation) {
          navNext = this.selector.querySelector(this.navigation.nextEl)
          navPrev = this.selector.querySelector(this.navigation.prevEl)
        }
        if (this.pagination) {
          pagin = this.selector.querySelector(this.pagination)
        }
        let swiper = new Swiper(this.selector, {
          speed : this.speed,
          autoplay: this.autoplay,
          effect: this.effect,
          fadeEffect: this.fadeEffect,
          disableOnInteraction: this.disableOnInteraction,
          spaceBetween : this.spaceBetween,
          slidesPerView : this.slidesPerView,
          breakpoints : this.breakPoints,
          autoHeight : this.autoHeight,
          slidesOffsetBefore: this.slidesOffsetBefore,
          slidesOffsetAfter: this.slidesOffsetAfter,
          pagination: {
            el: pagin,
            type: 'bullets',
          },
          navigation : {
            nextEl : navNext,
            prevEl : navPrev
          }
        });
      } else {
        Array.prototype.forEach.call(this.selector, (slctr) => {
          let navNext, navPrev, pagin
          if (this.navigation) {
            navNext = slctr.querySelector(this.navigation.nextEl)
            navPrev = slctr.querySelector(this.navigation.prevEl)
          }
          if (this.pagination) {
            pagin = slctr.querySelector(this.pagination)
          }
          let swiper = new Swiper(slctr, {
            speed : this.speed,
            autoplay: this.autoplay,
            effect: this.effect,
            fadeEffect: this.fadeEffect,
            spaceBetween : this.spaceBetween,
            slidesPerView : this.slidesPerView,
            breakpoints : this.breakPoints,
            autoHeight : this.autoHeight,
            slidesOffsetBefore: this.slidesOffsetBefore,
            slidesOffsetAfter: this.slidesOffsetAfter,
            pagination: {
              el: pagin,
              type: 'bullets',
            },
            navigation : {
              nextEl : navNext,
              prevEl : navPrev
            }
          })
        })
      }
    }
  }
}

const slideSecionsSwipers = document.querySelectorAll('.slide-section-swiper')
if (slideSecionsSwipers) {
  Array.prototype.forEach.call(slideSecionsSwipers, (slideSecionsSwiper) => {
    const slidesPerViewData = slideSecionsSwiper.getAttribute('data-slides')
    const isCentered = (slideSecionsSwiper.getAttribute('data-centered') === 'true') ? true : false
    const dataSpaceBetween = (slideSecionsSwiper.getAttribute('data-space-between')) ? parseInt(slideSecionsSwiper.getAttribute('data-space-between')) : 30
    const dataNavPos = slideSecionsSwiper.getAttribute('data-nav-pos')

    new Swiper(slideSecionsSwiper, {
      spaceBetween: 20,
      centeredSlides: isCentered,
      loop : isCentered,
      autoHeight: true,
      slidesPerView: slidesPerViewData,
      spaceBetween: dataSpaceBetween,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: slidesPerViewData,
          spaceBetween: dataSpaceBetween
        }
      }
    })

    if (dataNavPos === 'near-center') {
      if (window.matchMedia("(min-width: 992px)").matches) {
        const prevButton = slideSecionsSwiper.querySelector('.swiper-button-prev')
        const nextButton = slideSecionsSwiper.querySelector('.swiper-button-next')
        const activeSlide = slideSecionsSwiper.querySelector('.swiper-slide-active')
        prevButton.style.left = `${activeSlide.getBoundingClientRect().left - ((parseInt(dataSpaceBetween) / 2) + 15)}px`
        nextButton.style.right = `${(activeSlide.getBoundingClientRect().right - activeSlide.getBoundingClientRect().width) - ((parseInt(dataSpaceBetween) / 2) + 15)}px`
      } else {
        prevButton.style.left = '10px';
        nextButton.style.right = '10px';
      }
      window.addEventListener('resize', () => {
        if (window.matchMedia("(min-width: 992px)").matches) {
          const prevButton = slideSecionsSwiper.querySelector('.swiper-button-prev')
          const nextButton = slideSecionsSwiper.querySelector('.swiper-button-next')
          const activeSlide = slideSecionsSwiper.querySelector('.swiper-slide-active')
          prevButton.style.left = `${activeSlide.getBoundingClientRect().left - ((parseInt(dataSpaceBetween) / 2) + 15)}px`
          nextButton.style.right = `${(activeSlide.getBoundingClientRect().right - activeSlide.getBoundingClientRect().width) - ((parseInt(dataSpaceBetween) / 2) + 15)}px`
        } else {
          prevButton.style.left = '10px';
          nextButton.style.right = '10px';
        }
      })
    }
  })
}


const slideSecionsSmallSwipers = document.querySelectorAll('.slide-section-small-swiper')
if (slideSecionsSmallSwipers) {
  Array.prototype.forEach.call(slideSecionsSmallSwipers, (slideSecionsSwiper) => {
    const slidesPerViewData = slideSecionsSwiper.getAttribute('data-slides')
    new Swiper(slideSecionsSwiper, {
      centeredSlides: true,
      autoHeight: true,
      slidesPerView: 6,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        320: {
          centeredSlides: true,
          slidesPerView: 1.7,
          spaceBetween: 30,
        },
        768: {
          centeredSlides: true,
          slidesPerView: 3.1,
        },
        992: {
          slidesPerView: 3.7,
          centeredSlides: true,
        },
        1200: {
          slidesOffsetBefore: 30,
          slidesOffsetAfter: 30,
          slidesPerView: 3.2,
          centeredSlides: false,
        },
        1440: {
          slidesOffsetBefore: 40,
          slidesOffsetAfter: 40,
          slidesPerView: 3.4,
          centeredSlides: false,
        },
        1920: {
          slidesOffsetBefore: 40,
          slidesOffsetAfter: 40,
          slidesPerView: 5,
          centeredSlides: false,
        }
      }
    })
  })
}


const tabSliderSections = document.querySelectorAll('.slider_section_tabs')
Array.prototype.forEach.call(tabSliderSections, (tabSliderSection) => {
  const tabSlider = tabSliderSection.querySelector('.tab-slider-swiper')
  if (tabSlider) {
    let tabSwiper = new Swiper(tabSlider, {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
    })
    const tabSliderNavWrapper = tabSliderSection.querySelector('.swiper-nav-wrapper')
    if (tabSliderNavWrapper) {
      const tabSliderNav = tabSliderNavWrapper.querySelectorAll('.nav-item')
      if (tabSliderNav) {
        Array.prototype.forEach.call(tabSliderNav, (tabSliderNavItem, i) => {
          tabSliderNavItem.addEventListener('click', () => {
            const tabRect = tabSliderNavItem.getBoundingClientRect()
            const calcScrollPos = tabSliderNavItem.offsetLeft - (tabSliderNavWrapper.getBoundingClientRect().width / 2) + (tabRect.width / 2)
            tabSliderNavWrapper.scroll({
              left: calcScrollPos - 10,
              top: 0,
              behavior: 'smooth'
            })
            tabSwiper.slideTo(i)
            Array.prototype.forEach.call(tabSliderNav, (tabSliderNavItem, i) => {
              tabSliderNavItem.classList.remove('active-tab')
            })
            tabSliderNavItem.classList.add('active-tab')
          })
        })
      }
    }
  }
})
